<template>
  <div>
    <base-header :style="{ background: '#F7F8FD' }" class="py-6">
      <div class="row"></div>
    </base-header>
    <div class="container-fluid">
      <v-app>
        <card>
          <div class="row align-items-center p-3">
            <h2 class="col-6 m-0">Area Sales Mangers</h2>
            <div class="col-6 text-end">
              <v-btn
                class="mx-2"
                fab
                @click.prevent="add = !add"
                dark
                small
                color="#4D4B4B"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </div>
          </div>

          <div class="col-6">
            <v-text-field
              label="Search"
              v-model="search"
              append-icon="mdi-magnify"
            ></v-text-field>
          </div>

          <div class="table-responsive mt-4">
            <base-table
              class="align-items-center"
              thead-classes="thead-light"
              type="hover"
              :data="filteredList"
            >
              <template slot="columns">
                <th v-for="(header, index) in tableHeaders" :key="index">
                  {{ header }}
                </th>
              </template>
              <template slot-scope="{ row, index }">
                <td>{{ index + 1 }}</td>
                <td>{{ row.name }}</td>
                <td>{{ row.location }}</td>
                <td>
                  <!-- <i class="btn fas fa-eye" @click.prevent="viewProperty"></i> -->
                  <i
                    class="btn fas fa-pen"
                    @click.prevent="editASM(row.id)"
                  ></i>
                  <i
                    class="btn fas fa-trash text-danger"
                    @click.prevent="deleteASM({ row, index })"
                  ></i>
                </td>
              </template>
            </base-table>
          </div>
          <delete-dialog
            :data="filteredList"
            v-model="deleteItemIndex"
            actionString="deleteAsm"
            item="asm"
            :miscData="{ itemID: selectedItem }"
          >
            <span slot="warning">This ASM data will be removed! </span>
          </delete-dialog>
        </card>
      </v-app>
    </div>
    <AddASM :dialog.sync="add" />
    <EditASM :dialog.sync="edit" :id.sync="selectedItem" />
  </div>
</template>
<script>
import AddASM from "./AddASM.vue";
import EditASM from "./EditASM.vue";
export default {
  name: "ASM",
  components: {
    AddASM,
    EditASM,
  },
  data() {
    return {
      add: false,
      edit: false,
      deleteItemIndex: -1,
      selectedItem: null,
      tableHeaders: ["SL", "Name", "Location", "Actions"],
      filteredList: [],
      search: "",
    };
  },
  methods: {
    editASM(id) {
      this.selectedItem = id;
      this.edit = !this.edit;
    },
    deleteASM({ row, index }) {
      this.deleteItemIndex = index;
      this.selectedItem = row.id;
    },
    fetchAsmList() {
      this.$store.dispatch("fetchAsmList").catch((err) => {
        this.$notify({
          title: "Failed to fetch asm list",
          icon: "fa fa-exclamation-triangle",
          type: "danger",
          message: err.toString(),
        });
      });
    },
  },
  computed: {
    asmList() {
      return this.$store.state.asmStore.asmList;
    },
  },
  watch: {
    add() {
      this.fetchAsmList();
    },
    edit() {
      this.fetchAsmList();
    },
    asmList() {
      this.filteredList = [...this.asmList];
    },
    search() {
      if (this.search.trim() !== "") {
        this.filteredList = this.asmList.filter((item) =>
          item.name.toUpperCase().includes(this.search.toUpperCase())
        );
      } else {
        this.filteredList = [...this.asmList];
      }
    },
  },
  mounted() {
    this.fetchAsmList();
  },
};
</script>
<style scoped>
.test {
  color: blue;
}

.test:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
